import { h } from 'preact'; /** @jsx h */

import './CTABlock.scss';

const CTABlock = ({
    color = 'secondary',
    title,
    innerTitle,
    bulletPoints,
    buttonText,
    link,
    orientation = 'left',
    imageSrc,
    alt,
    divider = false,
    children
}) => {
    const buttonTextParts = buttonText.split(' - ');
    const isMobile = window.innerWidth < 768;
    return (
        <div className={`cta-block-wrapper color-${color}`}>
            {divider && <div className="divider" />}
            <div className="title-container">
                <h2 className="title" dangerouslySetInnerHTML={{ __html: title }} />
            </div>
            <div className={`help-1-1-block orientation-${orientation}`}>
                <div className="help-image-container">
                    <img src={imageSrc} alt={alt} />
                </div>
                <div className="help-text-container">
                    <div className="help-text-content">
                        <h3 className="help-title">{innerTitle}</h3>
                        {children && <div className="help-text">{children}</div>}
                        {bulletPoints && bulletPoints.length > 0 && (
                            <ul className="help-list">
                                {bulletPoints.map((bullet, index) => (
                                    <li className="help-list-item" key={index}>
                                        {bullet}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div className="btn-container">
                        <a className="link-btn" href={link}>
                            <span>
                                {isMobile && buttonTextParts.length > 1 ? (
                                    <span className="cta-link-mobile-text">
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: buttonTextParts[0]
                                            }}
                                        />
                                        {/* <span
                                            dangerouslySetInnerHTML={{
                                                __html: buttonTextParts[1]
                                            }}
                                        /> */}
                                    </span>
                                ) : (
                                    <span
                                        className="link-text"
                                        dangerouslySetInnerHTML={{
                                            __html: buttonText
                                        }}
                                    />
                                )}
                            </span>
                            <span className="material-symbols-outlined">arrow_forward</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CTABlock;
